export enum UserRoleEnum {
  ROLE_SUPERUSER = 'ROLE_SUPERUSER',
  ROLE_ADMIN = 'ROLE_ADMIN',
  ROLE_USER = 'ROLE_USER',
  ROLE_EXECUTIVE_GROUP = 'ROLE_EXECUTIVE_GROUP',
  ROLE_GAMIFICATION_ADMIN = 'ROLE_GAMIFICATION_ADMIN',
}
